import React, { useEffect, useState } from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { FiRefreshCcw } from 'react-icons/fi';
import { ImSpinner2 } from 'react-icons/im';
import * as applicationUser from '../../../configurations/crud/applicationUserCrud';
import { MdErrorOutline } from 'react-icons/md';
import { useToast } from '../../controls/Toast/ToastService'
import useGlobalLoader from '../../../configurations/useGlobalLoader';


export default function Getbalance() {
  const { start, end } = useGlobalLoader()
  const [available, setAvailable] = useState(0);
  const [loading, setLoading] = useState(true);
  const toast = useToast()


  useEffect(() => {
    getbalance();
  }, []);

  const getbalance = () => {
    setLoading(true);
    start()
    applicationUser.Getbalance()
      .then(res => {
        const mdata = res.data;
        if (mdata.result.succeeded) {
          setAvailable(mdata);
        } else {
          setAvailable([]);
        }
        setLoading(false);
        end()
      })
      .catch(errors => {
        setAvailable([]);
        setLoading(false);
        end()
        toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
      });
  };

  return (
    <div className="mb-4">
      <div className="w-full border rounded-3xl shadow-xl bg-brand-50 hover:shadow-2xl border-gray-300 text-xs sm:text-sm p-2.5">
        <div className="flex justify-between items-center flex-wrap gap-2">

          <div className="flex items-center flex-wrap gap-1 text-xs sm:text-sm">
            <span className="text-blue-600 font-medium">Balance</span>
            <FaArrowRight className="text-blue-600 text-xs mt-0.5" />

            {loading ? (
              <ImSpinner2 className="animate-spin text-green-600 text-lg" />
            ) : (
              <>
                <span className="text-green-600 font-semibold">
                  {available.opdBalance} OPD available
                </span>
                <span className="text-blue-600">
                  and {available.opdUsedBalance} OPD used
                </span>
                <span className="text-gray-500">|</span>
                <span className="text-green-600 font-semibold">
                  {available.smsBalance} SMS available
                </span>
                <span className="text-blue-600">
                  and {available.smsUsedBalance} SMS used
                </span>
              </>
            )}
          </div>

          <div>
            <button
              title="Refresh"
              className="p-1 text-green-700 hover:bg-gray-200 hover:rounded-lg active:bg-gray-300 active:rounded-lg"
              onClick={getbalance}
            >
              <FiRefreshCcw />
            </button>
          </div>
        </div>
      </div>
    </div>
  );

}
